/** Lightweight toast — matches vanilla copyBankNo feedback */
export function showCopyTip(message = 'คัดลอกแล้ว') {
  const tip = document.createElement('div')
  tip.className = 'copy-bank-tip'
  tip.textContent = message
  document.body.appendChild(tip)
  requestAnimationFrame(() => tip.classList.add('copy-bank-tip--show'))
  window.setTimeout(() => {
    tip.classList.remove('copy-bank-tip--show')
    window.setTimeout(() => tip.remove(), 300)
  }, 1800)
}
